'use client';

import React from 'react';
import * as PhosphorIcons from '@phosphor-icons/react';
import { Box, Card as MuiCard, CardContent, CardMedia, Stack, Typography } from '@unity/cloud-ui';
import { Link } from '../link';

interface CardProps {
  title: string;
  href: string;
  icon?: string;
  iconSrc?: string;
  src?: string;
  alt?: string;
}

export const Card = (props: React.PropsWithChildren<CardProps>) => {
  const { title, children, href = '', icon, iconSrc, src, alt } = props;

  const getPhosphorIcon = (iconName) => {
    const availableIcons = Object.keys(PhosphorIcons);
    if (!iconName || !availableIcons.includes(iconName)) {
      return null;
    }

    return PhosphorIcons[iconName];
  };

  const Icon = getPhosphorIcon(icon);

  return (
    <Link href={href}>
      <MuiCard
        variant="outlined"
        sx={({ vars, transitions }) => ({
          height: '100%',
          borderRadius: '16px',
          transition: `background-color ${transitions.duration.standard}ms`,
          backgroundColor: vars.palette.background.paperElevation0,
          '&:hover': {
            backgroundColor: vars.palette.background.paperElevation1,
          },
        })}
      >
        <CardContent sx={{ padding: 2, ':last-child': { paddingBottom: 2 } }}>
          <Stack gap={1}>
            {src && <CardMedia sx={{ mb: 1 }} component="img" height="250" image={src} alt={alt || title} />}
            {!!Icon && (
              <Box color="primary.main">
                <Icon title={icon} size={24} aria-hidden="true" focusable="false" />
              </Box>
            )}
            {iconSrc && (
              <div>
                <Box component="img" src={iconSrc} alt={alt || title} height={32} />
              </div>
            )}
            <Box>
              <Stack gap={0.5}>
                <Typography variant="h3" component="span">
                  {title}
                </Typography>
                <Typography component="span" color="text.secondary">
                  {children}
                </Typography>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </MuiCard>
    </Link>
  );
};

export default Card;
